import type { AsyncOptionsProps } from "./types";

type AsyncOptionsInput = AsyncOptionsProps & {
  disabled?: boolean;
  error?: React.ReactNode;
};

type AsyncOptionsState = {
  displayedError: React.ReactNode;
  isDisabled: boolean;
  retry: (() => void) | undefined;
};

const getAsyncOptionsState = ({
  disabled,
  error,
  fetchError,
  loading,
  onRetry,
}: AsyncOptionsInput): AsyncOptionsState => ({
  displayedError: error ?? fetchError,
  isDisabled: !!disabled || !!loading || !!fetchError,
  retry: !error && fetchError ? onRetry : undefined,
});

export { getAsyncOptionsState, type AsyncOptionsState };
